import React from "react";
import Seo from "../components/seo";
import BaseLayout from "../containers/BaseLayout";
import Terms from "../sections/Terms/terms";
import '../globalStyles.css';

const TermsConditions = () => {
    return (
        <BaseLayout>
            <Seo title={"Terms & Conditions"} />
            <Terms />
        </BaseLayout>
    );
};

export default TermsConditions;